import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { omit } from "ramda";
import { Flex, Header2, IconButton } from "@base-ui";
import { useOpen, useClickOutside, useCustomEffect } from "hooks";
import { headerHeight, MeasuresSearch, MainSiteNavButton, MenuToggleButton } from "./header.styles";
import HeaderNav from "./HeaderNav";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Header(_ref) {
  var adminAccess = _ref.adminAccess,
    searchOptions = _ref.searchOptions,
    searchQuery = _ref.searchQuery,
    setSearchQuery = _ref.setSearchQuery,
    measuresCategories = _ref.measuresCategories,
    reportCategories = _ref.reportCategories;
  var _useOpen = useOpen(false),
    openNav = _useOpen.open,
    setOpenNav = _useOpen.setOpen;
  var _useOpen2 = useOpen(false),
    openSearch = _useOpen2.open,
    toggleSearchOpen = _useOpen2.toggleOpen;
  var location = useLocation();
  var headerRef = useRef();
  var menuRef = useRef();
  useClickOutside(headerRef, function () {
    return setOpenNav(false);
  }, openNav);
  useCustomEffect(function () {
    if (openNav) setOpenNav(false);
  }, [location.pathname]);
  var handleEsc = function handleEsc() {
    menuRef.current.focus();
    setOpenNav(false);
  };
  return /*#__PURE__*/_jsxs(Flex.Column, {
    bg: "P1",
    zIndex: "101",
    as: "header",
    children: [/*#__PURE__*/_jsxs(Flex.Row, {
      height: headerHeight,
      justifyContent: "space-between",
      onKeyDown: function onKeyDown(e) {
        return e.keyCode === 27 && openNav && handleEsc();
      },
      ref: headerRef,
      children: [/*#__PURE__*/_jsx(Header2, {
        className: "hidden-styles",
        id: "site-menu-header",
        children: "V\xE5rden i siffror, huvudmeny"
      }), /*#__PURE__*/_jsx(MainSiteNavButton, {
        renderAs: "a",
        href: "/",
        mr: "sm",
        children: "V\xC5RDEN I SIFFROR"
      }), /*#__PURE__*/_jsxs(Flex.Row, {
        as: "nav",
        width: "fit-content",
        children: [/*#__PURE__*/_jsx(MenuToggleButton, {
          ref: menuRef,
          href: "#",
          "aria-haspopup": true,
          "aria-expanded": openNav === "main",
          "aria-controls": "site-navigation",
          variant: "header",
          onClick: function onClick(e) {
            e.preventDefault();
            document.activeElement.blur();
            setOpenNav("main");
          },
          iconAfter: "menu",
          children: "Meny"
        }), /*#__PURE__*/_jsx(IconButton, {
          id: "open-site-measures-search",
          label: "Aktivera f\xF6r att expandera s\xF6ken",
          "aria-controls": "search-measures-on-site",
          "aria-expanded": openSearch,
          icon: "search",
          height: "100%",
          inverted: true,
          onClick: toggleSearchOpen
        }), /*#__PURE__*/_jsx(HeaderNav, {
          measuresCategories: measuresCategories,
          reportCategories: reportCategories,
          open: openNav,
          setOpen: setOpenNav,
          adminAccess: adminAccess,
          closeMenu: function closeMenu() {
            return setOpenNav(false);
          }
        })]
      })]
    }), /*#__PURE__*/_jsx(MeasuresSearch, {
      id: "search-measures-on-site",
      className: openSearch ? "open" : "",
      label: "S\xF6k efter indikatorer i systemet",
      hideLabel: true,
      inverted: true,
      options: searchOptions,
      searchString: (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.q) || "",
      search: function search(q) {
        return (q === null || q === void 0 ? void 0 : q.length) > 0 ? setSearchQuery({
          q: q
        }) : setSearchQuery(omit(["q"]));
      },
      placeholder: "S\xF6k efter indikatorer..."
    })]
  });
}